export const BRP_FINANCIAL_IDENTIFIER = 'brp-financial';
export const BUFFALO_IDENTIFIER = 'buffalo';

export const isBrpFinancialIdentifier = (identifier) => (
    identifier === BRP_FINANCIAL_IDENTIFIER || identifier === BUFFALO_IDENTIFIER
);
